import { type FC } from 'react';
import { type PlantType } from '@common/types/common';
import { type FactoryTypeText } from '@common/types/factory';
import { type PlantTypeText } from '@common/types/plant';
import { type ResourceTypeText } from '@common/types/resource';
import {
  selectActiveBoostForQuarry,
  selectAdsBoostForQuarry,
  selectBoostX5ForQuarry,
  selectBoostX10ForQuarry,
  selectFreeBoostForQuarry,
  selectPaidBoostForQuarry,
  selectQuarriesList,
  selectTotalQuarryBoostById,
  selectVipBoostForQuarry,
} from '@redux/selectors/quarrySelectors';
import { useAppSelector } from '@redux/store';

import { useBoostFirebaseEvents } from '@/common/hooks/boost-firebase-events';
import { type GoodsType } from '@/common/types/goods';
import { BoostFirebaseEventsContext } from '@/context/BoostFirebaseEventContext';

import { BoostCardList } from './BoostCardList/BoostCardList';

interface BoostQuarryProps {
  plantType: PlantType;
  plantId: string;
  plant: PlantTypeText | ResourceTypeText | FactoryTypeText;
  item: PlantTypeText | ResourceTypeText | GoodsType;
  level: number;
}

const BoostQuarry: FC<BoostQuarryProps> = ({
  plantId,
  plant,
  plantType,
  level,
  item,
}) => {
  const freeBoost = useAppSelector((state) =>
    selectFreeBoostForQuarry(state, plantId),
  );
  const adsBoost = useAppSelector((state) =>
    selectAdsBoostForQuarry(state, plantId),
  );
  const vipBoost = useAppSelector((state) =>
    selectVipBoostForQuarry(state, plantId),
  );
  const paidBoost = useAppSelector((state) =>
    selectPaidBoostForQuarry(state, plantId),
  );
  const boostX5 = useAppSelector((state) =>
    selectBoostX5ForQuarry(state, plantId),
  );
  const boostX10 = useAppSelector((state) =>
    selectBoostX10ForQuarry(state, plantId),
  );
  const totalBoost = useAppSelector((state) =>
    selectTotalQuarryBoostById(state, plantId),
  );
  const quarriesList = useAppSelector(selectQuarriesList);
  const activeBoost = useAppSelector(selectActiveBoostForQuarry);
  const events = useBoostFirebaseEvents(
    { id: plantId, level, name: plant },
    activeBoost,
    quarriesList,
  );

  return (
    <BoostFirebaseEventsContext.Provider value={events}>
      <BoostCardList
        item={item}
        plant={plant}
        plantId={plantId}
        plantType={plantType}
        forAllPlantlist={[freeBoost, vipBoost]}
        forCurrentPlantList={[adsBoost, paidBoost, boostX5, boostX10]}
        totalBoost={totalBoost}
        level={level}
      />
    </BoostFirebaseEventsContext.Provider>
  );
};

export { BoostQuarry };
